var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 7C0 3.1325 3.1325 0 7 0C10.8675 0 14 3.1325 14 7C14 10.8675 10.8675 14 7 14C3.1325 14 0 10.8675 0 7ZM10.4161 3.90605C10.2208 3.71079 9.90421 3.71079 9.70895 3.90605L6.04105 7.57395C5.84579 7.76921 5.52921 7.76921 5.33395 7.57395L4.29105 6.53105C4.09579 6.33579 3.77921 6.33579 3.58395 6.53105L3.03105 7.08395C2.83579 7.27921 2.83579 7.59579 3.03105 7.79105L5.33395 10.0939C5.52921 10.2892 5.84579 10.2892 6.04105 10.0939L10.9689 5.16605C11.1642 4.97079 11.1642 4.65421 10.9689 4.45895L10.4161 3.90605Z"
})));
export default SvgCheck;